import { useQueryClient } from '@tanstack/react-query';

import {
	NETWORK_ELEMENT_CHANGE_MONITORING,
	NETWORK_ELEMENT_CHANGE_MONITORING_HISTORY,
} from '@constants/queryKeys';

const useInvalidateChangeMonitoring = () => {
	const queryClient = useQueryClient();

	const invalidateAlarmsChangeMonitoring = () => {
		return [
			queryClient.invalidateQueries([NETWORK_ELEMENT_CHANGE_MONITORING]),
			queryClient.invalidateQueries([NETWORK_ELEMENT_CHANGE_MONITORING_HISTORY]),
		];
	};

	return {
		invalidateAlarmsChangeMonitoring,
	};
};

export default useInvalidateChangeMonitoring;
